<template>
  <v-layout row wrap justify-space-between>
    <v-flex xs12 md12 lg12>
      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">flag</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Nivel</v-list-tile-title>
            <v-list-tile-sub-title v-if="subgroup.level">
              {{ subgroup.level.typeLevel }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">group</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Grado y grupo</v-list-tile-title>
            <v-list-tile-sub-title v-if="subgroup.grade">
              {{ subgroup.grade.name }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">reorder</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Orden</v-list-tile-title>
            <v-list-tile-sub-title v-if="subgroup.order">
              {{ subgroup.order | orderFilter }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">verified</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Número de subgrupos</v-list-tile-title>
            <v-list-tile-sub-title v-if="subgroup.divider">
              {{ subgroup.divider }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-flex>
    <v-flex xs12 md12 lg12>
      <v-layout wrap row justify-space-between v-for="(day, i) in subgroup.days" :key="i" id="days-subgroups" mt-3>
        <v-flex xs12>
          <spam class="subheading">
            Subgrupo {{ i + 1 }} 
          </spam>
          <span> Vigencia del subgrupo {{ (day.startDate || new Date()).toLocaleString('es-MX', {month: 'numeric', day: '2-digit', year: '2-digit'}) }} | {{ (day.endDate || new Date()).toLocaleString('es-MX', {month: 'numeric', day: '2-digit', year: '2-digit'}) }} </span> 
        </v-flex>
        <v-flex xs12 v-for="(name, j) in selectedDays(day)" :key="j">
          <span class="body-1 grey--text">{{ name }}</span>
        </v-flex>
        </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    props: ["subgroup"],
    data: () => ({
    }),
    methods:{
      viewAudiency(){
          this.modals.showAudiency = true;
      },
      onCancel() {
          this.modals.showAudiency = false;
          this.$emit("closedPopup");
      },
      selectedDays(day) {
        var flags = [day.monday,day.tuesday,day.wednesday,day.thursday,day.friday,day.saturday,day.sunday];
        var names = ["Lunes","Martes","Miercoles","Jueves","Viernes","Sábado","Domingo"];
        return names.filter(function(name, index) {
          return flags[index];
        });
      }
    },
    filters: {
      orderFilter: function (value) {
        switch (value) {
          case "RANDOM":
            return "Aleatoriamente";
          case "ALPHABETICAL":
            return "Alfabéticamente";  
        }
      },
    },
};
</script>

<style>
</style>